import type { Nudge, NudgeStatus, NudgesResponse } from 'types/Nudge';

import { getRequest, patchRequest } from '../../methods';

const getMyNudges = (): Promise<NudgesResponse> =>
  getRequest('users/me/nudges');

const updateNudgeStatus = (
  id: Nudge['id'],
  status: NudgeStatus
): Promise<Nudge> => patchRequest(`nudges/${id}`, { nudge: { status } });

const nudges = {
  getMyNudges,
  updateNudgeStatus,
};

export default nudges;
